<template>
  <div class="table-row settings-users-table-columns">
    <div class="settings-users-table__cell">
      <UserInfo v-if="member" :key="member.id" :user="member" :show-position="false" />
    </div>
    <div class="settings-users-table__cell vertical-centering">
      <span class="text-sm file-title">{{ member.position }}</span>
    </div>
    <div class="settings-users-table__cell vertical-centering">
      <div
        v-if="member.role"
        class="text-sm"
        :class="{ 'text-tertiary': isInvitedMember }"
        style="text-transform: capitalize"
      >
        {{ role }}
      </div>
    </div>
    <button
      v-if="isRegularMember"
      type="button"
      class="settings-users-table__cell vertical-centering cell__btn"
      @click="$emit('delete', member.id)"
    >
      <Icon type="x" size="16" color="secondary" />
    </button>
    <div v-else class="settings-users-table__cell" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import UserInfo from '@/components/ui/UserInfo';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ProjectTeammate',
    components: {
      UserInfo,
      Icon,
    },
    props: {
      member: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['roles']),
      role() {
        return this.isInvitedMember ? this.$t('Invited') : this.roles[this.member.role];
      },
      isInvitedMember() {
        return this.isRegularMember && !this.member.is_activated;
      },
      isRegularMember() {
        return this.member.role === 'regular';
      },
    },
  };
</script>
